import { lazy } from 'react';
import { Notfound } from '@/components';
import type { RouteProps } from 'react-router-dom';

const CartLayout = lazy(() => import('./index'));
const Cart = lazy(() => import('./cart'));
const ApplyContract = lazy(() => import('./apply-contract'));
const Inquiry = lazy(() => import('./inquiry'));

/** 路由配置 */
export const routeConfig: (RouteProps & { subChildren?: RouteProps[] })[] = [
  {
    path: '/cart',
    element: <CartLayout />,
    subChildren: [
      {
        path: '',
        element: <Cart />,
      },
      {
        path: 'apply-contract',
        element: <ApplyContract />,
      },
      {
        path: 'inquiry',
        element: <Inquiry />,
      },
      {
        path: '*',
        element: <Notfound />,
      },
    ],
  },
];
